module.exports = __webpack_public_path__ + "img/console.20c30827.svg";